import countries from "world-countries"

const allowedCountries = [
    "AL", "DZ", "AD", "AO", "AI", "AG", "AR", "AM", "AW", "AU",
    "AT", "AZ", "BS", "BH", "BD", "BB", "BE", "BZ", "BJ", "BM",
    "BO", "BA", "BW", "BR", "VG", "BN", "BG", "BF", "BI", "KH",
    "CM", "CA", "CV", "KY", "TD", "CL", "CN", "CO", "KM", "CG",
    "CK", "CR", "CI", "HR", "CW", "CY", "CZ", "DK", "DJ", "DM",
    "DO", "TL", "EC", "EG", "SV", "GQ", "EE", "ET", "FK", "FO",
    "FJ", "FI", "FR", "GF", "PF", "GA", "GM", "GE", "DE", "GH",
    "GI", "GR", "GL", "GD", "GP", "GT", "GG", "GN", "GW", "GY",
    "HT", "HN", "HK", "HU", "IS", "IN", "ID", "IE", "IM", "IL",
    "IT", "JM", "JP", "JE", "JO", "KZ", "KE", "KI", "KR", "KW",
    "KG", "LA", "LV", "LB", "LS", "LR", "LI", "LT", "LU", "MO",
    "MG", "MW", "MY", "MV", "MT", "MQ", "MR", "MU", "YT", "MX",
    "MD", "MC", "MN", "ME", "MS", "MA", "MZ", "NA", "NR", "NP",
    "NL", "NC", "NZ", "NI", "NG", "NU", "MK", "NO", "OM", "PK",
    "PA", "PG", "PH", "PY", "PE", "PL", "PT", "QA", "RE", "RO", "RW",
    "KN", "LC", "VC", "WS", "SM", "ST", "SA", "SN", "RS", "SC",
    "SL", "SG", "SX", "SK", "SI", "SB", "ZA", "ES", "LK", "BL",
    "MF", "SH", "SR", "SZ", "SE", "CH", "TW", "TZ", "TH", "TG",
    "TO", "TT", "TN", "TM", "TC", "TV", "UG", "AE", "GB", "US",
    "UY", "UZ", "VU", "VA", "VE", "VN", "WF", "ZM", "ZW", 
];

const priorityCountries = ["US", "GB", "AU", "PH"]

export const countryCurrencies = countries
  .map((country) => {
    const code = country.cca2
    const currencyCodes = Object.keys(country.currencies || {})
    const currencyCode = currencyCodes[0]
    const currencyInfo = country.currencies?.[currencyCode]

    if (!code || !currencyCode || !currencyInfo) return null

    return {
      countryCode: code,
      currencyCode: currencyCode,
      countryName: country?.name?.common,
      label: currencyInfo.name,
      priority: priorityCountries.includes(code) ? 1 : 0, // priority flag
    }
  })
  .filter(Boolean) // remove nulls
  .filter((c) => allowedCountries.includes(c.countryCode)) // filter only allowed
  .sort((a, b) => {
    // sort by priority first, then by country name
    if (b.priority !== a.priority) {
      return b.priority - a.priority
    }
    return a.countryName.localeCompare(b.countryName)
  })